import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import WarrantyLogo from 'shared/components/WarrantyLogo/WarrantyLogo';
import ModalContainer from 'shared/components/ModalContainer/ModalContainer';
import GreenCheckBox from 'shared/assets/images/GreenCheckbox.png';
import cx from 'classnames';
import s from './WarrantyModal.css';

const isMobile = __APP__ === 'mobile';

class WarrantyModal extends React.Component {
  static propTypes = {
    warranty: PropTypes.shape().isRequired,
    switchModal: PropTypes.func.isRequired,
    showModal: PropTypes.bool.isRequired,
  };

  render() {
    const { warranty, showModal, switchModal } = this.props;

    return (
      <ModalContainer
        modalCN={cx(s.modal, { [s.mobileModal]: isMobile })}
        onClose={switchModal}
        isOpen={showModal}
      >
        <div onClick={switchModal} className={isMobile ? s.mobileRoot : s.desktopRoot}>
          <div className={s.modalWarrantyBlock}>
            <WarrantyLogo warranty={warranty} tooltipTitle={s.tooltipTitle} />
          </div>
          <div className={s.description}>{warranty.description}</div>
          <div>
            {warranty.options.map(item => (
              <div className={s.modalOptions} key={item.title}>
                <img
                  src={GreenCheckBox}
                  className={cx(s.checkboxIcon, { [s.mobileCheckboxIcon]: isMobile })}
                  alt=""
                />
                <div className={cx(s.optionTitles, { [s.mobileOptionTitles]: isMobile })}>
                  {item.title}
                </div>
                <div className={cx(s.optionDescription, s.description)}>{item.description}</div>
              </div>
            ))}
          </div>
        </div>
        <span className={s.closeBtn} onClick={switchModal} />
      </ModalContainer>
    );
  }
}

export default withStyles(s)(WarrantyModal);



// WEBPACK FOOTER //
// ./src/desktop/components/WarrantyModal/WarrantyModal.js